<template>
<v-card style="height:90vh">

<v-toolbar height="42" color="#242F3B" dark flat>
<v-card-title class="ma-0 pa-0">
<span  style="font-size:1.4em">   Параметры сообщества -  {{this.groups.paramsItem.id_of_group}}  </span>

</v-card-title>
<v-spacer></v-spacer>
<v-icon  @click="close()"> mdi-close</v-icon>
</v-toolbar>



<v-card-text>



<div>
<b-card no-body>
<b-tabs   card>

<b-tab>

<template #title>
<v-icon small color="#FF8F18">mdi-flash</v-icon> <strong style="margin-left:5px">Автообновление</strong>
</template>


<div>
<v-checkbox v-model="params.autoupdate.mute" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Не обновлять автоматически</span>
</v-checkbox>
</div>

<div>
<v-checkbox disabled v-model="params.autoupdate.stopThenBots.is" hide-details  color="#232F3A"  >
<span style="color:grey;margin-top:6px" slot="label">Приостановление автообновления по причине подписок ботов</span>
</v-checkbox>
<div v-if="params.autoupdate.stopThenBots.is">
<b-alert show variant="info">
Запретить обновление на {{params.autoupdate.stopThenBots.stopTime}} минут, если из {{params.autoupdate.stopThenBots.lastFollowersCount}} последних вступивших - {{params.autoupdate.stopThenBots.botPercent}}% ботов
</b-alert>
<v-layout style="margin-left:15px">
<v-flex md5>
<v-subheader>Запрет в минутах</v-subheader>
<v-slider v-model="params.autoupdate.stopThenBots.stopTime"
max="180"
min="1"
color="primary"
thumb-label="always"
></v-slider>
</v-flex>
<v-flex md5 style="margin-left:25px">
<v-subheader>Количество последних вступивших</v-subheader>
<v-slider v-model="params.autoupdate.stopThenBots.lastFollowersCount"
max="100"
min="1"
color="primary"
thumb-label="always"
></v-slider>
</v-flex>
<v-flex md5 style="margin-left:25px">
<v-subheader>Процент ботов</v-subheader>
<v-slider v-model="params.autoupdate.stopThenBots.botPercent"
max="100"
min="1"
color="primary"
thumb-label="always"
></v-slider>
</v-flex>
</v-layout>
</div>
</div>

<div v-show="false">
<v-checkbox v-model="params.autoupdate.intervalUpdate.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Обязательное периодическое обновление</span>
</v-checkbox>
<div v-if="params.autoupdate.intervalUpdate.is">
<b-alert show variant="info">
Парсить новых подписчиков с интервалом в {{params.autoupdate.intervalUpdate.hours}} часа(ов) и {{params.autoupdate.intervalUpdate.minutes}} минут(ты)
</b-alert>
<v-layout style="margin-left:15px">
<v-flex md5>
<v-subheader>Часы</v-subheader>
<v-slider v-model="params.autoupdate.intervalUpdate.hours"
max="24"
min="0"
color="primary"
thumb-label="always"
></v-slider>
</v-flex>
<v-flex md5 style="margin-left:25px">
<v-subheader>Минуты</v-subheader>
<v-slider v-model="params.autoupdate.intervalUpdate.minutes"
max="59"
min="0"
color="primary"
thumb-label="always"
></v-slider>
</v-flex>

</v-layout>
</div>
</div>

<div>
<v-checkbox v-model="params.autoupdate.restrictUpdates.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Ограничить количество обновлений во времени ?</span>
</v-checkbox>
<div v-if="params.autoupdate.restrictUpdates.is">
<b-alert show variant="info">
Не более одного обновления за {{params.autoupdate.restrictUpdates.minutes}} минут(ты)
</b-alert>
<v-layout style="margin-left:15px">
<v-flex md5>
<v-subheader>Минуты</v-subheader>
<v-slider v-model="params.autoupdate.restrictUpdates.minutes"
max="60"
min="1"
color="primary"
thumb-label="always"
></v-slider>
</v-flex>


</v-layout>
</div>
</div>


</b-tab>


<b-tab>

<template #title>
<v-icon small color="yellow">mdi-tune</v-icon> <strong style="margin-left:5px">Другое</strong>
</template>

</b-tab>

</b-tabs>
</b-card>
</div>

<v-btn style="text-transform:none"   color="#4A76A8"   flat @click="chParams()" block>
<v-icon> mdi-content-save</v-icon> <span style="margin-left:5px">Сохранить настройки</span>
</v-btn>

</v-card-text>
<v-snackbar v-model="sb.snackbar" :color="sb.color" absolute top :timeout="2000">
{{sb.text}}
<v-btn dark flat @click="sb.snackbar = false">ОК</v-btn>
</v-snackbar>
</v-card>

</template>
<script>

import axios from 'axios'
export default {
components:{},
props: ['modals','groups'],
data () {
return {
params:{
autoupdate:{
mute:false,
stopThenBots:{
is:false,
stopTime:90,
lastFollowersCount:10,
botPercent:70
},
intervalUpdate:{
is:false,
hours:0,
minutes:0,
},
restrictUpdates:{
is:false,
minutes:0,
}
},
params:{
bots:[]
},
},
sb:{
snackbar: false,
color: 'success',
text: ''
},
}
},
methods:{

messageAct(){
if( this.creator.newTask.actions.messageSend.activated ){
this.creator.newTask.actions.messageSend.activated = true
this.creator.newTask.modals.message = true
}else{
this.creator.newTask.actions.messageSend.activated =  false
}
},

close(){
this.groups.modals.gr_params = false
},

chParams(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/ch_group_params.php', {
method: 'POST',
data: {id: this.groups.paramsItem.id_of_group, params:this.params}
})
.then( response => {
this.sb.text = "Уникальные настройки сообщества id"+this.groups.paramsItem.id_of_group+" успешно изменены"
this.sb.snackbar = true
setTimeout(()=>{this.groups.modals.gr_params = false},2300)
})

}
},
computed:{
},
mounted(){
if(Object.entries(this.groups.paramsItem.params).length){
this.params = Object.assign(this.params, this.groups.paramsItem.params)
}
},

}
</script>

<style    >

</style>
